import React from 'react';
import { WidgetSettings } from 'types';

import { WatchedAsset } from '@kaltura-ott/tvpil-shared';

import DynamicGridViewer from 'components/pages/Grids/DynamicGridViewer/DynamicGridViewer';
import ContinueWatchingCardContainer from 'components/widgets/CardView/ContinueWatching/ContinueWatchingCardContainer/ContinueWatchingCardContainer';
import { WidgetProviderData } from 'context/widgetProvider/types';
import WidgetProvider from 'context/widgetProvider/widgetProvider';

interface Props {
  type: string;
  settings: WidgetSettings;
  data: WidgetProviderData<WatchedAsset>;
}

function ContinueWatchingGridContainer({ type, settings, data }: Props) {

  return (
    <WidgetProvider<WatchedAsset> isGrid type={type} settings={settings} data={data}>
      <DynamicGridViewer<WatchedAsset>>
        {({ imageHeight, itemWidth, data: watchedAsset }) => (
          <ContinueWatchingCardContainer imageHeight={imageHeight} itemWidth={itemWidth} item={watchedAsset} />
        )}
      </DynamicGridViewer>
    </WidgetProvider>
  );
}

export { ContinueWatchingGridContainer };
